import React from "react";
import { Nav } from "../layouts/headernew";
import { ToothZapFooter2 } from "../layouts/footernew";
import "../style/terms.css";
export const Termsandconditions: React.FC = () => {
  return (
    <div>
      <Nav />

      {/* LEGAL SECTION */}
      <section className="legal-section">
        <div className="container">
          <div className="row">
            <div className="col-md-10 mx-auto">

            
          <h1 className="legal-title">Terms & Conditions</h1>
          <p className="legal-date">Last updated: March 13, 2026</p>

          <div className="legal-content">
            <p>
              These Terms and Conditions govern how visitors, clinics, labs, and other
              users interact with the ToothZap website and any related workflow,
              scheduling, or partner coordination services. By using this website or
              submitting information through a ToothZap form, you agree to use the
              service only for lawful business, clinical, or informational purposes.
            </p>

            <p>
              ToothZap provides workflow coordination, informational content, and
              partner-network infrastructure, but treatment decisions remain the
              responsibility of the treating dentist or clinical provider. Nothing on
              this website should be interpreted as a diagnosis, medical opinion, or a
              guarantee that every case is suitable for same-day restorative
              treatment.
            </p>

            <p>
              Clinics and milling partners are responsible for the accuracy of any
              information they submit, including contact details, operational claims,
              turnaround capacity, and production readiness. ToothZap may suspend,
              remove, or refuse listings or partner access if information appears
              inaccurate, misleading, incomplete, or inconsistent with network quality
              standards.
            </p>

            <p>
              Website content, branding, copy, and interface elements are owned by
              ToothZap or used with permission and may not be copied, republished, or
              redistributed without prior written approval. Limited use for internal
              evaluation, clinic review, or partnership assessment is permitted where
              that use does not misrepresent the service or imply endorsement.
            </p>

            <p>
              ToothZap may update these terms as the service evolves, including
              changes to workflows, eligibility, onboarding requirements, and partner
              expectations. Continued use of the website after an update means the
              user accepts the revised terms as posted on this page.
            </p>
          </div>
        </div>
        </div>
          </div>
      </section>

      <ToothZapFooter2 />
    </div>
  );
};

export default Termsandconditions;